import { useMemo, useState } from "react"
import useProducts from "./useProducts"

const useProductableAdjustments = (defaultProducts = [], searchQuery) => {
  const [items, setItems] = useState(defaultProducts)
  const { products: allProducts, isLoading } = useProducts({ searchQuery })

  // Filter out products that are already in items
  const products = useMemo(() => {
    return allProducts.filter(
      (product) => !items.some((item) => item.id === product.id)
    )
  }, [allProducts, items])

  const handleAddedItem = (selected) => {
    const productToAdd = allProducts.find((product) => product.id === selected)
    if (!productToAdd) return

    setItems((prevItems) => [
      ...prevItems,
      {
        ...productToAdd,
        quantity: 1,
        discount: 0,
        price: productToAdd.sell_price,
      },
    ])
  }

  const handleRemoveItem = (itemToRemove) => {
    setItems((prevItems) =>
      prevItems.filter((item) => item.id !== itemToRemove.id)
    )
  }

  const handleQuantityChange = (index, newValue) => {
    const updatedItems = [...items]
    updatedItems[index].quantity = Number(newValue)
    updatedItems[index].price =
      updatedItems[index].quantity * updatedItems[index].sell_price
    setItems(updatedItems)
  }

  const handlePriceChange = (index, newValue) => {
    const updatedItems = [...items]
    updatedItems[index].price = Number(newValue)
    setItems(updatedItems)
  }

  const handleTypeChange = (index, newValue) => {
    const updatedItems = [...items]
    updatedItems[index].type = newValue
    setItems(updatedItems)
  }

  const handleReasonChange = (index, newValue) => {
    const updatedItems = [...items]
    updatedItems[index].reason = newValue
    setItems(updatedItems)
  }

  const handleReset = () => {
    setItems(defaultProducts)
  }

  return {
    products,
    items,
    isLoading,
    handleAddedItem,
    handleRemoveItem,
    handleQuantityChange,
    handlePriceChange,
    handleReset,
    handleReasonChange,
    handleTypeChange,
  }
}

export default useProductableAdjustments
